/* ================================================================
   B L C K  M R K T  — theme.js
   blckmrkt.shop
   ================================================================ */

'use strict';

// ── Helpers ──────────────────────────────────────────────────────

/** Simple fetch wrapper that always returns JSON, throws on !ok */
function apiFetch(url, options) {
  return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, options))
    .then(function(r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
}

/** Format Shopify money (cents) → e.g. "$34.00" */
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/** Debounce */
function debounce(fn, ms) {
  var t;
  return function() { clearTimeout(t); t = setTimeout(fn.bind(this, arguments), ms); };
}

// ── Cart State ───────────────────────────────────────────────────
// Single source of truth for the current cart.
// Refreshes via /cart.js and re-renders the drawer HTML.

var CartState = {
  data: null,

  fetch: function() {
    return apiFetch('/cart.js')
      .then(function(cart) {
        CartState.data = cart;
        CartState.render();
        return cart;
      });
  },

  add: function(variantId, quantity) {
    quantity = quantity || 1;
    return apiFetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function() {
      return CartState.fetch();
    });
  },

  change: function(key, quantity) {
    return apiFetch('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(cart) {
      CartState.data = cart;
      CartState.render();
      return cart;
    });
  },

  render: function() {
    var cart  = CartState.data;
    if (!cart) return;

    // Update all badge counts
    var count = cart.item_count;
    document.querySelectorAll('.cart-badge').forEach(function(el) {
      el.textContent     = count;
      el.style.display   = count > 0 ? '' : 'none';
    });

    // Update subtotal
    var subtotalEl = document.getElementById('cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Re-render items list
    var itemsEl = document.getElementById('cart-drawer-items');
    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="cart-empty-state"><p class="prompt" style="color:var(--white-dim);">BAG IS EMPTY</p><p style="font-family:var(--font-mono);font-size:9px;color:var(--white-dim);margin-top:8px;letter-spacing:.1em;">// START ADDING ITEMS</p></div>';
      return;
    }

    var html = '';
    cart.items.forEach(function(item) {
      var imgSrc = item.image ? item.image.replace('.jpg', '_120x160_crop_center.jpg').replace('.png', '_120x160_crop_center.png') : '';
      // Fallback: use original if transform failed
      if (!imgSrc && item.image) imgSrc = item.image;

      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '';

      html += '<div class="cart-item" data-key="' + item.key + '">'
        + '<a href="' + item.url + '" class="cart-item__img-link">'
        + (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title.replace(/"/g, '&quot;') + '" class="cart-item__img" loading="lazy">' : '')
        + '</a>'
        + '<div class="cart-item__info">'
        + '<p class="cart-item__vendor">' + (item.vendor || '').toUpperCase() + '</p>'
        + '<a href="' + item.url + '" class="cart-item__title">' + item.product_title.toUpperCase() + '</a>'
        + variantLine
        + '<p class="cart-item__price">' + formatMoney(item.final_line_price) + '</p>'
        + '<div class="cart-item__qty">'
        + '<button type="button" class="cart-qty-btn" data-key="' + item.key + '" data-action="decrease" aria-label="Decrease">−</button>'
        + '<span class="cart-qty-num">' + item.quantity + '</span>'
        + '<button type="button" class="cart-qty-btn" data-key="' + item.key + '" data-action="increase" aria-label="Increase">+</button>'
        + '<button type="button" class="cart-remove-btn" data-key="' + item.key + '">[ REMOVE ]</button>'
        + '</div>'
        + '</div>'
        + '</div>';
    });

    itemsEl.innerHTML = html;
  }
};

// ── Boot on DOMContentLoaded ─────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {

  // Fetch initial cart state silently (updates badge count)
  CartState.fetch().catch(function() {});

  // ── Mobile Nav ───────────────────────────────────────────────
  var navOverlay  = document.getElementById('mobile-nav-overlay');
  var navDrawer   = document.getElementById('mobile-nav');

  function openNav() {
    navOverlay && navOverlay.classList.add('open');
    navDrawer  && navDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    navOverlay && navOverlay.classList.remove('open');
    navDrawer  && navDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-open-nav]').forEach(function(b)  { b.addEventListener('click', openNav); });
  document.querySelectorAll('[data-close-nav]').forEach(function(b) { b.addEventListener('click', closeNav); });
  navOverlay && navOverlay.addEventListener('click', closeNav);
  navDrawer  && navDrawer.querySelectorAll('a').forEach(function(a) { a.addEventListener('click', closeNav); });

  // ── Cart Drawer ──────────────────────────────────────────────
  var cartOverlay = document.getElementById('cart-overlay');
  var cartDrawer  = document.getElementById('cart-drawer');

  function openCart() {
    if (!cartDrawer) return;
    cartOverlay && cartOverlay.classList.add('open');
    cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    // Update aria
    document.querySelectorAll('[data-open-cart]').forEach(function(b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeCart() {
    cartOverlay && cartOverlay.classList.remove('open');
    cartDrawer  && cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
    document.querySelectorAll('[data-open-cart]').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
  }

  document.querySelectorAll('[data-open-cart]').forEach(function(b)  { b.addEventListener('click', openCart); });
  document.querySelectorAll('[data-close-cart]').forEach(function(b) { b.addEventListener('click', closeCart); });
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  // Escape key closes both drawers
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { closeCart(); closeNav(); }
  });

  // ── Cart Drawer — qty / remove ───────────────────────────────
  // Event delegation so it works after JS re-renders the items HTML
  document.addEventListener('click', function(e) {

    // Quantity buttons
    var qtyBtn = e.target.closest('.cart-qty-btn');
    if (qtyBtn) {
      var key     = qtyBtn.getAttribute('data-key');
      var action  = qtyBtn.getAttribute('data-action');
      var itemEl  = qtyBtn.closest('.cart-item');
      var qtySpan = itemEl && itemEl.querySelector('.cart-qty-num');
      var current = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
      var next    = action === 'increase' ? current + 1 : Math.max(0, current - 1);
      qtyBtn.disabled = true;
      CartState.change(key, next).catch(function() {}).finally(function() {
        qtyBtn.disabled = false;
      });
      return;
    }

    // Remove button
    var removeBtn = e.target.closest('.cart-remove-btn');
    if (removeBtn) {
      var key = removeBtn.getAttribute('data-key');
      removeBtn.textContent = '[ REMOVING... ]';
      CartState.change(key, 0).catch(function() {});
      return;
    }

    // Quick-add buttons on product cards
    var quickBtn = e.target.closest('.product-card__quick-add');
    if (quickBtn && quickBtn.tagName === 'BUTTON') {
      e.preventDefault();
      var variantId = quickBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      var origText = quickBtn.textContent;
      quickBtn.textContent = '[ ADDING... ]';
      quickBtn.disabled    = true;
      CartState.add(variantId, 1)
        .then(function() {
          quickBtn.textContent = '[ ADDED ✓ ]';
          quickBtn.style.cssText = 'color:var(--black)!important;background:var(--green)!important;border-color:var(--green)!important;';
          setTimeout(function() { openCart(); }, 300);
          setTimeout(function() {
            quickBtn.textContent   = origText;
            quickBtn.style.cssText = '';
            quickBtn.disabled      = false;
          }, 1600);
        })
        .catch(function(err) {
          console.error('Quick-add failed:', err);
          quickBtn.textContent   = '[ TRY AGAIN ]';
          quickBtn.style.cssText = 'color:var(--red)!important;border-color:var(--red)!important;';
          setTimeout(function() {
            quickBtn.textContent   = origText;
            quickBtn.style.cssText = '';
            quickBtn.disabled      = false;
          }, 2000);
        });
      return;
    }

  });

  // ── Product Gallery (PDP) — unified image swap + arrow nav ──────────────
  // pdpGoTo is declared in outer scope so variant selector can call it
  // even before this block fully executes (both are inside DOMContentLoaded).
  var pdpGoTo = null;

  (function() {
    var mainImg   = document.getElementById('pdp-main-img');
    var thumbWrap = document.getElementById('pg-thumbs');
    if (!mainImg) return;

    var thumbs  = thumbWrap ? Array.from(thumbWrap.querySelectorAll('.product-thumb')) : [];
    var prevBtn = document.getElementById('pdp-prev');
    var nextBtn = document.getElementById('pdp-next');
    var current = 0;

    // Build src list from data-src on each thumb button.
    // If no thumbs (single image product), build a 1-item array from the main img src.
    var srcs = thumbs.length > 0
      ? thumbs.map(function(t) { return t.getAttribute('data-src'); })
      : (mainImg.src ? [mainImg.src] : []);

    function goTo(idx) {
      if (srcs.length === 0) return;
      idx = ((idx % srcs.length) + srcs.length) % srcs.length;
      current = idx;
      var newSrc = srcs[idx];
      if (!newSrc) return;

      // Always update thumb highlights first
      thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === idx); });
      if (thumbs[idx] && thumbWrap) {
        thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      // Compare by path only (strip protocol/host) to avoid http vs https vs // mismatch
      var currentPath = mainImg.src.replace(/^https?:/, '').split('?')[0];
      var newPath     = newSrc.replace(/^https?:/, '').split('?')[0];
      if (currentPath === newPath) return; // truly the same image, skip fade

      // Fade out → set src → fade in
      // Use direct assignment — don't rely on tmp Image onload (breaks with cached images)
      mainImg.style.opacity = '0';
      mainImg.src = newSrc;
      // Fade back in — use requestAnimationFrame to ensure browser registers src change
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          mainImg.style.opacity = '1';
        });
      });
    }

    // Share with variant selector
    pdpGoTo = goTo;

    // Thumb clicks — use event delegation for robustness
    if (thumbWrap) {
      thumbWrap.addEventListener('click', function(e) {
        var btn = e.target.closest('.product-thumb');
        if (!btn) return;
        var idx = parseInt(btn.getAttribute('data-index'), 10);
        if (!isNaN(idx)) goTo(idx);
      });
    }

    // Arrow buttons
    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.preventDefault(); goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.preventDefault(); goTo(current + 1); });

    // Swipe on main image
    var tx = 0;
    mainImg.addEventListener('touchstart', function(e) { tx = e.touches[0].clientX; }, { passive: true });
    mainImg.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
    }, { passive: true });

    mainImg.style.transition = 'opacity 0.15s ease';
  })();

  // ── Product Page — variant selector, color→image switch, add to cart ───
  var pdpForm = document.getElementById('pdp-form');
  if (pdpForm) {

    var variantsEl = document.getElementById('pdp-variants-json');
    var imagesEl   = document.getElementById('pdp-images-json');
    var variants   = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var imageMap   = imagesEl   ? JSON.parse(imagesEl.textContent)   : {};
    var idInput    = document.getElementById('pdp-variant-id');
    var priceEl    = document.getElementById('pdp-price');
    var compareEl  = document.getElementById('pdp-compare');
    var availEl    = document.getElementById('pdp-availability');
    var addBtn     = document.getElementById('pdp-add-btn');
    var colorLabel = document.getElementById('pdp-color-name');

    // Collect selected option values from .is-selected buttons
    function getSelected() {
      var indices = [];
      pdpForm.querySelectorAll('[data-option].is-selected').forEach(function(btn) {
        var i = parseInt(btn.getAttribute('data-option'), 10);
        indices[i] = btn.getAttribute('data-value');
      });
      return indices;
    }

    function findVariant(selected) {
      return variants.find(function(v) {
        return selected.every(function(val, i) {
          return v['option' + (i + 1)] === val;
        });
      });
    }

    // Switch gallery image — uses shared pdpGoTo var initialised below
    function pgGoToIndex(idx) {
      if (typeof pdpGoTo === 'function') pdpGoTo(idx);
    }

    function updateVariant() {
      var selected = getSelected();
      var match    = findVariant(selected);
      if (!match) return;

      // Update hidden form input
      idInput.value = match.id;

      // Price
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent   = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // Availability
      if (availEl && addBtn) {
        if (match.available) {
          availEl.textContent    = '';
          addBtn.textContent     = '[ ADD TO BAG ]';
          addBtn.disabled        = false;
          addBtn.style.cssText   = '';
        } else {
          availEl.textContent    = '// THIS VARIANT IS SOLD OUT';
          availEl.style.color    = 'var(--red)';
          addBtn.textContent     = '[ SOLD OUT ]';
          addBtn.disabled        = true;
        }
      }

      // Switch gallery to the variant's featured image
      if (match.featured_image && match.featured_image.id) {
        var imgIdx = imageMap[String(match.featured_image.id)];
        if (imgIdx !== undefined) pgGoToIndex(imgIdx);
      }
    }

    // Option button click (size buttons + color swatches)
    pdpForm.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-option][data-value]');
      if (!btn) return;

      var optIdx = btn.getAttribute('data-option');

      // Deselect siblings in same option group
      pdpForm.querySelectorAll('[data-option="' + optIdx + '"]').forEach(function(s) {
        s.classList.remove('is-selected');
        s.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');

      // Update color label
      if (btn.classList.contains('color-swatch') && colorLabel) {
        colorLabel.textContent = btn.getAttribute('data-value').toUpperCase();
      }

      updateVariant();

      // If button has a direct data-image-id, jump gallery to that image immediately
      // (faster than waiting for updateVariant to look it up via variant JSON)
      var directImgId = btn.getAttribute('data-image-id');
      if (directImgId && directImgId !== '') {
        var directIdx = imageMap[String(directImgId)];
        if (directIdx !== undefined) pgGoToIndex(directIdx);
      }
    });

    // Form submit — AJAX add to cart, no page reload
    pdpForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (!addBtn || addBtn.disabled) return;

      var origText = addBtn.textContent;
      addBtn.textContent = '[ ADDING... ]';
      addBtn.disabled    = true;

      CartState.add(idInput.value, 1)
        .then(function() {
          addBtn.textContent   = '[ ADDED TO BAG ✓ ]';
          addBtn.style.cssText = 'color:var(--black)!important;background:var(--green)!important;border-color:var(--green)!important;';
          setTimeout(function() { openCart(); }, 350);
          setTimeout(function() {
            addBtn.textContent   = origText;
            addBtn.style.cssText = '';
            addBtn.disabled      = false;
          }, 2000);
        })
        .catch(function(err) {
          console.error('Add to cart failed:', err);
          addBtn.textContent   = '[ TRY AGAIN ]';
          addBtn.style.cssText = 'color:var(--red)!important;border-color:var(--red)!important;';
          setTimeout(function() {
            addBtn.textContent   = origText;
            addBtn.style.cssText = '';
            addBtn.disabled      = false;
          }, 2500);
        });
    });
  }

  // ── Product Card Image Swiper ─────────────────────────────────
  // CSS scroll-snap handles the actual swiping.
  // JS handles: 6-dot display cap, arrow buttons, quick-add unlock on mobile.
  document.querySelectorAll('.product-card').forEach(function(card) {
    var slidesWrap = card.querySelector('[data-slides]');
    if (!slidesWrap) return;

    var slides   = Array.from(slidesWrap.querySelectorAll('.product-card__slide'));
    if (slides.length < 2) return;

    var dots     = Array.from(card.querySelectorAll('.product-card__dot:not(.product-card__dot--more)'));
    var moreDot  = card.querySelector('.product-card__dot--more');
    var prevBtn  = card.querySelector('.product-card__arrow--prev');
    var nextBtn  = card.querySelector('.product-card__arrow--next');
    var didSwipe = false;
    var touchStartX = 0;
    var DOT_CAP  = 6; // max dots shown

    function currentIndex() {
      var w = slidesWrap.offsetWidth;
      return w > 0 ? Math.round(slidesWrap.scrollLeft / w) : 0;
    }

    function goTo(idx) {
      var count = slides.length;
      idx = ((idx % count) + count) % count;
      slidesWrap.scrollTo({ left: idx * slidesWrap.offsetWidth, behavior: 'smooth' });
    }

    // Sync up to 6 dots. If slide index >= 6, light up the last dot (overflow indicator).
    function syncDots() {
      var idx = currentIndex();
      var dotIdx = idx < DOT_CAP ? idx : DOT_CAP - 1;
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === dotIdx); });
      if (moreDot) moreDot.classList.toggle('is-active', idx >= DOT_CAP);
    }

    var scrollTimer;
    slidesWrap.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncDots, 60);
    }, { passive: true });

    // Arrow click: navigate + unlock quick-add on first interaction (mobile)
    function onArrow(e, dir) {
      e.preventDefault();
      e.stopPropagation();
      goTo(currentIndex() + dir);
      // First arrow tap on a touch device reveals the quick-add button
      if (!card.classList.contains('is-unlocked')) {
        card.classList.add('is-unlocked');
      }
    }
    if (prevBtn) prevBtn.addEventListener('click', function(e) { onArrow(e, -1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { onArrow(e,  1); });

    // Track touch to block accidental link-click mid-swipe
    slidesWrap.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      didSwipe    = false;
    }, { passive: true });
    slidesWrap.addEventListener('touchmove', function(e) {
      if (Math.abs(e.touches[0].clientX - touchStartX) > 6) didSwipe = true;
    }, { passive: true });
    // Also unlock quick-add when user swipes (not just arrow tap)
    slidesWrap.addEventListener('touchend', function() {
      if (didSwipe && !card.classList.contains('is-unlocked')) {
        card.classList.add('is-unlocked');
      }
    }, { passive: true });
    slidesWrap.addEventListener('click', function(e) {
      if (didSwipe) { e.preventDefault(); e.stopPropagation(); didSwipe = false; }
    }, true);
  });


  // ── Boot sequence type-in ────────────────────────────────────
  var bootLines = [
    'INITIALIZING BLCK MRKT...',
    'ENCRYPTION: AES-256 [ACTIVE]',
    'LOADING PROPAGANDA...',
    'ACCESS GRANTED.',
  ];
  function typeInto(el) {
    if (!el) return;
    var li = 0, ci = 0, out = '';
    function type() {
      if (li >= bootLines.length) { el.classList.add('prompt-cursor'); return; }
      var line = bootLines[li];
      if (ci < line.length) { out += line[ci]; el.textContent = out; ci++; setTimeout(type, 22 + Math.random() * 26); }
      else { out += '\n'; el.textContent = out; li++; ci = 0; setTimeout(type, 140); }
    }
    setTimeout(type, 500);
  }
  typeInto(document.getElementById('boot-text'));
  typeInto(document.getElementById('boot-text-mobile'));

  // ── Scroll-triggered glitch ──────────────────────────────────
  var glitchTargets = Array.from(document.querySelectorAll('.js-scroll-glitch, .site-logo'));
  var glitchCooldown = false;
  var lastScrollY    = window.scrollY;

  window.addEventListener('scroll', function() {
    requestAnimationFrame(function() {
      var current = window.scrollY;
      var delta   = Math.abs(current - lastScrollY);
      if (delta > 80 && !glitchCooldown) {
        glitchCooldown = true;
        glitchTargets.forEach(function(el) {
          el.classList.add('is-glitching');
          el.style.textShadow = '3px 0 #FF2222,-3px 0 #00FFFF,0 0 12px rgba(0,255,65,1)';
        });
        setTimeout(function() {
          glitchTargets.forEach(function(el) {
            el.classList.remove('is-glitching');
            el.style.textShadow = '';
          });
        }, 280);
        setTimeout(function() { glitchCooldown = false; }, 900);
        lastScrollY = current;
      }
    });
  }, { passive: true });

  // ── Ambient random glitch (footer/section headings) ──────────
  var ambientEls = Array.from(document.querySelectorAll('.vt-xl, .vt-lg, .footer-logo'));
  function randomGlitch() {
    if (!ambientEls.length) return;
    var el = ambientEls[Math.floor(Math.random() * ambientEls.length)];
    if (el) {
      el.style.textShadow = '2px 0 #FF2222,-2px 0 #00FFFF,0 0 8px rgba(0,255,65,.9)';
      setTimeout(function() { el.style.textShadow = ''; }, 90);
    }
    setTimeout(randomGlitch, 4000 + Math.random() * 8000);
  }
  setTimeout(randomGlitch, 5000);

});
